import { FC } from "react";
import { useTranslation } from "react-i18next";
import SDoc from "@/components/SDoc";
import SaleTabPane, { TabProps } from "@/components/TabPane";
import { ApproveStatusEnum, ReimbursRequest } from "@/types/reimburse";
import ReimburseList from "./components/ReimburseList";
import usePage from "@/layout/hooks/usePage";
import { PageId } from "@/types/page";

type CustomerTabType = 'doc'

const ReimburseHome: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "list"
  const TAB_DOC_KEY = "doc"

  const { pageId } = usePage();

  const keyObj: (info: ReimbursRequest) => { [key in CustomerTabType]: TabProps } = (info) => ({
    doc: {
      key: TAB_DOC_KEY,
      label: (info.number) + ' ' + t('common.attachment'),
      children: <SDoc docId={info.dirId} isRead={pageId !== PageId.REIMBURSE_MINE || ![ApproveStatusEnum.DRAFT, ApproveStatusEnum.RETURNED].includes(info.status)} />
    },
  })


  return <SaleTabPane<ReimbursRequest> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("reimburse.applicationList"),
      children: <ReimburseList />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default ReimburseHome;